import { render, staticRenderFns } from "./Projektstunden.vue?vue&type=template&id=3fbf2c50&scoped=true"
import script from "./Projektstunden.vue?vue&type=script&lang=ts"
export * from "./Projektstunden.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fbf2c50",
  null
  
)

export default component.exports